export const DAG_MOCK_MUTATION_DELAY_MS = {
  fast: 700,
  standard: 1000,
} as const;

type DagMockMutationDelaySpeed = keyof typeof DAG_MOCK_MUTATION_DELAY_MS;

export const delayDagMockMutation = (speed: DagMockMutationDelaySpeed = 'standard'): Promise<void> => {
  return new Promise((resolve) => {
    globalThis.setTimeout(resolve, DAG_MOCK_MUTATION_DELAY_MS[speed]);
  });
};
